module.exports = __webpack_public_path__ + "img/mlt_x_newag_xl.68afb05d.jpg";